import * as React from 'react';
import classNames from 'classnames';
import Icon, { IconsAvailable } from '@/components/ui/Icon';
import styles from '@/components/ui/ListMissions/styles.module.scss';

export type IMissionsCalloutIntent = 'default' | 'success' | 'danger';

export interface IMissionCalloutProps {
  label: React.ReactNode;
  shortLabel: React.ReactNode;
  icon: IconsAvailable;
  intent: IMissionsCalloutIntent;
}

const ListMissionsCallout: React.FunctionComponent<IMissionCalloutProps> = (props) => {
  return (
    <div
      className={classNames(styles['list-missions-item__callout'], {
        [styles['theme-default']]: props.intent === 'default' || !props.intent,
        [styles['theme-danger']]: props.intent === 'danger',
        [styles['theme-success']]: props.intent === 'success',
      })}
    >
      <Icon
        width={16}
        height={16}
        kind={props.icon}
      />
      <span className={styles['short']}>{props.shortLabel}</span>
      <span className={styles['long']}>{props.label}</span>
    </div>
  );
};

ListMissionsCallout.displayName = 'ListMissionsCallout';

export default ListMissionsCallout;
